const COMMON = {
  USER_PROFILE: 'پروفایل کاربری',

  // profile drop down
  PACK_TYPE: 'نوع پکیج',
  REMAINING_CONVS: 'مکالمه ی باقی مانده',
  REMAINING_DAYS: 'روز باقی مانده',
  UPGRADE_PACKAGE: 'تمدید یا ارتقا پکیج',
  CHARGE_CONVS: 'خرید شارژ مکالمه',
  BILLS_LIST: 'لیست صورتحساب',
  PROFILE: '',
  COMPLETE_INFO: 'تکمیل اطلاعات',
  EXIT: 'خروج',
  UNLIMITED_CONVS_TITLE: 'نامحدود',
  DAYS_SUFFIX: 'روز',

  MOBILE_FIELD_PLACEHOLDER: 'موبایل - ********۰۹۱',
  EMAIL_PLACEHOLDER: 'ایمیل',

  TODAY: 'امروز',
  SATURDAY: 'شنبه',
  SUNDAY: 'یکشنبه',
  MONDAY: 'دوشنبه',
  TUESDAY: 'سه‌شنبه',
  WEDNESDAY: 'چهارشنبه',
  THURSDAY: 'پنجشنبه',
  FRIDAY: 'جمعه',

  MONTH_1: 'فروردین',
  MONTH_2: 'اردیبهشت',
  MONTH_3: 'خرداد',
  MONTH_4: 'تیر',
  MONTH_5: 'مرداد',
  MONTH_6: 'شهریور',
  MONTH_7: 'مهر',
  MONTH_8: 'آبان',
  MONTH_9: 'آذر',
  MONTH_10: 'دی',
  MONTH_11: 'بهمن',
  MONTH_12: 'اسفند',

  MODAL: {
    PROFILE_TITLE: '',
    PROFILE_AVATAR_HINT: '',
    PROFILE_AVATAR_UPLOAD: '',
    PROFILE_FORM_FULL_NAME: '',
    PROFILE_FORM_TITLE: '',
    PROFILE_FORM_PHONE: '',
    PROFILE_FORM_EMAIL: '',
    PROFILE_FORM_PASSWORD: '',
    PROFILE_FORM_PASSWORD_CONFIRM: '',
    PROFILE_OPERATORS_LIST_TITLE: '',
    PROFILE_FORM_CONFIRM: '',

    CANCEL: '',
  },

  INFO_LAW_TAB: 'حقوقی',
  INFO_PERSON_TAB: 'حقیقی',

  INFO_LAW_NAME: 'نام كامل شركت',
  INFO_LAW_NATIONAL_CODE: 'شناسه ملی',
  INFO_LAW_ECONOMIC: 'كد اقتصادی',
  INFO_LAW_REGISTER: 'شماره ثبت',
  INFO_LAW_PHONE: 'تلفن ثابت (به همراه پيش شماره)',
  INFO_LAW_POST: 'كد پستی',
  INFO_LAW_ADDRESS: 'آدرس',

  INFO_PERSON_NAME: 'نام',
  INFO_PERSON_LAST_NAME: 'نام خانوادگی',
  INFO_PERSON_NATIONAL: 'كد ملی',
  INFO_PERSON_PHONE: 'تلفن ثابت (به همراه پيش شماره)',
  INFO_PERSON_POST: 'كد پستی',
  INFO_PERSON_ADDRESS: 'آدرس',

  USER_INFO_ADDRESS_PLACEHOLDER_DEFAULT:
    'آدرس (فاكتور به اين آدرس ارسال می شود)',
  USER_INFO_MOBILE_VERIFY_SUBMIT: 'بررسی و ذخيره تغييرات',

  WEBSITE_SELECT_TITLE: 'انتخاب وبسایت',

  FREE_PACKAGE_OVERLAY:
    'این قسمت در پکیج رایگان در دسترس نمیباشد.برای استفاده پکیج خود را ارتقا دهید.',
  SUBMIT_MODAL_BTN: 'تایید',
  CANCEL_MODAL_BTN: 'انصراف',

  // Date picker
  YESTERDAY: 'دیروز',
  PAST_SEVEN_DAYS: '7روز گذشته',
  PAST_14_DAYS: '14روز گذشته',
  PAST_ONE_YEAR: '1سال گذشته',
  DATE_PICKER_SUBMIT: 'تایید',

  TIME_PICKER_AM_LABEL: 'ق ظ',
  TIME_PICKER_PM_LABEL: 'ب ظ',

  CANCEL_BTN_DEFAULT: 'انصراف',
  SUBMIT_BTN_DEFAULT: 'تایید',
  REMOVE_BTN_DEFAULT: 'حذف',
  SAVE_BTN_DEFAULT: 'ذخیره',

  // selectbox
  SELECT_BOX_TITLE: 'انتخاب',
  SELECT_BOX_EMPTY: 'لیست خالی است',

  // verification card
  VERIFY_CARD: {
    TITLE: 'کد تایید',
    TRY_AGAIN: 'دوباره تلاش کنید',
    NOT_RECIEVED: 'کد تایید را دریافت نکردید؟',
  },

  // verification form
  VERIFICATION_FORM: {
    CODE_PLACEHOLDER: 'کد تایید را اینجا وارد کنید',
    SUBMIT_BTN: 'بررسی و ادامه',
    CANCEL_BTN: 'بازگشت',
  },

  // verification modal
  MOBILE_VERIFICATION_MODAL: {
    TITLE: 'تاييد موبايل',
    CODE_PLACEHOLDER: 'کد تایید را اینجا وارد کنید',
    NOT_RECIEVED: 'کد تایید را دریافت نکردید؟',
    TRY_AGAIN: 'دوباره تلاش کنید',
  },

  WIDGET_GENERATION_CARD: {
    TITLE: 'اطلاعات وب سایت',
    DESCRIPTION: 'آدرس و عنوان وب سایتی که قصد نصب ابزارک را دارید وارد کنید.',
  },

  DOCUMENT_PAGE_TITLE: 'داشبورد | رايچت',

  NEW_FEAT_BADGE: 'جدید',

  // packages
  PREMIUM_PACKAGE: 'پریمیوم',
  commercial_PACKAGE: 'تجاری',
  BASE_PACKAGE: 'پایه',

  // QUOTES
  QUOTE_1: {
    NAME: 'عادل طالبی',
    TEXT: 'از چت های آنلاین زیادی استفاده کرده ام مثل زوپیم، کریسپ، جیو چت و ... سه نکته در رایچت برای ما اهمیت حیاتی دارد. سادگی استفاده، پرداخت ریالی و کیفیت پشتیبانی بالا',
  },

  QUOTE_2: {
    NAME: 'حميدرضا احدی',
    TEXT: 'خیلی خوشحالم که رای‌چت تونسته یک سرویس مفید و به صرفه به ما ارائه بده که پشتیبانی بتونه از تلگرام و دردسرهای مربوطه راحت بشه.',
  },

  POPUP_MESSAGE: {
    CLOSE_DEFAULT: 'متوجه شدم',
    NEVER_SHOW_DEFAULT: 'دیگه این پیام رو نمایش نده',
  },

  ENTER_PAGE_ADDRESS_PLACEHOLDER: 'آدرس صفحه را وارد کنید',

  // MULTI SELECT BOX
  MULTI_SELECT_BOX_TITLE: ' مورد انتخاب شده',
  MULTI_SELECT_BOX_EMPTY_LIST: 'ایتمی وجود ندارد!',

  BTN_DISABLED_PURCHASE_LINK_TITLE: 'خرید',

  BROWSER_NOT_SUPPORTING_VIDEO_FILE:
    'مرورگر شما فایل ویدئویی را پشتیبانی نمی‌کند',

  NEW_UPDATES_BRO: 'آپدیت های جدید :)',

  // signup
  ENTERED_CODE_WRONG_TRY_AGAIN:
    'كد وارد شده اشتباه است. لطفا دوباره تلاش كنيد.',

  USER_INFO_MODAL: {
    SUBMIT_BTN: 'تایید اطلاعات',
    CHECK_BTN: 'بررسی',
  },
};

export default COMMON;
